<app-common-country-hero [heroData]="heroHeader"></app-common-country-hero>
<app-local-trusted-way-section
  [pageData]="pageData"
  [hasInside]="true"
></app-local-trusted-way-section>
<app-features-section [pageData]="pageData"></app-features-section>
<app-unified-solutions [pageData]="pageData"></app-unified-solutions>
<app-common-subproducts-whitepaper
  [whitePaperData]="whitePaperData"
></app-common-subproducts-whitepaper>
<app-common-discover-why
  [discoverData]="discoverData"
  [hideTrustPilot]="true"
></app-common-discover-why>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
